import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { canConfirm, getUserType } from "../permissions";
import API_BASE from "../config";

const paymentModes = ["Cash", "Cheque/DD", "RTGS", "Phonepe/UPI"];
const paymentForOptions = [
    "Booking", "Plot", "Construction Stage", "Registry Charges",
    "Maintenence Charges", "Extra Work", "Deduction", "Club House Charges",
    "Building Permission Charge", "Loan Closure Return", "Loan Processing",
    "Nagar Palika Permission", "Electricity Meter", "Other",
];
const paymentToOptions = [
    "Sainath Buildcon SBI 6543", "Sainath Buildcon BOB 350", "Sainath Buildcon BOM", "Sainath Buildcon ICICI 298", "SBRE Pvt. Ltd. Kotak Bank"," SAI PHOENIX SBI",
"SAI PHOENIX HDFC ", "Amarjyoti Bhadoriya Indian Bank" , "Amarjyoti Bhadoriya BOB 2/245" , "Amarjyoti Bhadoriya ICICI BANK 1188", 
"Amarjyoti Bhadoriya SBI 620",
"Ashok Kumar Malviya SBI Bank",
"Pacific Infra Axis Bank",
"Sai Aarti Homes 1207",
"Sai Aarti Homes 1180", 
"Sai Aarti Parisar Extention BOB 1194",
"Shailendra Chouksey BOB",
"MSB UPI",
"DSR UPI",
"DSR KOTAK BANK 6769",
    "SBRE ICICI 422 BABAI",
"SBRE ICICI 420 INDORE",
"AMARJYOTI BHADORIYA SAI ELITE ROYAL BOB ITARSI 2/493",
"AMARJYOTI BHADORIYA SAI FORTUNE BOB BABAI",
"AMARJYOTI BHADORIYA AXIS A/C",
"AMARJYOTI BHADORIYA MPGB A/C",
"AMARJYOTI BHADORIYA KOTAK BANK",
"MSB UPI AXIS BANK",
"Pacific Infra BOB  Bank",
"SAI ELITE ICON KOTAK 4207",
];
const paymentParts = ["Self", "Bank Loan"];
const receivedByOptions = ["DSR", "MSB", "Bhawna Madam", "Mangli Chourey","Rajendra Das", "Rohit Dehariya","Mukesh Ahirwar", "Home", "Uttam Singh" , "Ambesh Singhariya"];
const handoverToOptions = ["Uttam Singh", "Mukesh Ahirwar", "DSR", "Home", "MSB","Rohit Dehariya", "Mangli Chourey"];
const bankOptions = ["SBI", "HDFC", "ICICI", "Indian Bank", "BOB", "KGB", "Au Bank", "PNB", "Bank Of Maharashtra", "Union Bank", "Central Bank", "IDFC"];

const DetailRow = ({ label, value, icon }) => (
    <div className="cp-detail-row">
        <span className="cp-detail-label">{icon && <span className="cp-detail-icon">{icon}</span>}{label}</span>
        <span className="cp-detail-value">{value || "—"}</span>
    </div>
);

const EditableInput = ({ label, name, value, icon, onChange, type = "text", placeholder = "", prev }) => (
    <div className="cp-edit-row">
        <label className="cp-edit-label">{icon && <span className="cp-edit-icon">{icon}</span>}{label}</label>
        <input
            className="cp-edit-input"
            type={type}
            name={name}
            value={value !== "" ? value : (prev || "")}
            onChange={onChange}
            placeholder={placeholder || label}
        />
    </div>
);

const EditableSelect = ({ label, name, value, icon, options, onChange, prev }) => {
    // If there's a previous value that isn't in the options list, add it
    const allOptions = [...options];
    if (prev && !allOptions.some(opt => (opt.name || opt) === prev)) {
        allOptions.push(prev);
    }
    
    return (
        <div className="cp-edit-row">
            <label className="cp-edit-label">{icon && <span className="cp-edit-icon">{icon}</span>}{label}</label>
            <select
                className="cp-edit-input"
                name={name}
                value={value !== "" ? value : (prev || "")}
                onChange={onChange}
            >
                <option value="">— Select {label} —</option>
                {allOptions.map((opt) => (
                    <option key={opt.name || opt} value={opt.name || opt}>{opt.name || opt}</option>
                ))}
            </select>
        </div>
    );
};

const ConfirmPayment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const payment = location.state?.payment;
    const userType = getUserType();
    const allowConfirm = canConfirm(userType, "unconfirm_payments");

    const [confirming, setConfirming] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    // Editable fields initialized with existing values
    const [editFields, setEditFields] = useState({
        payment_part: payment?.payment_part || "",
        payment_for: payment?.payment_for || "",
        payment_to: payment?.payment_to || "",
        payment_mode: payment?.payment_mode || "",
        handover: payment?.handover || "",
        received_by: payment?.received_by || "",
        cheque_no: payment?.cheque_no || "",
        cheque_bank: payment?.cheque_bank || "",
        cheque_date: payment?.cheque_date || "",
        utr: payment?.utr || "",
    });

    if (!payment || !allowConfirm) {
        navigate(-1);
        return null;
    }

    const fmt = (v) => {
        const n = Number(v);
        return isNaN(n) || n === 0 ? "—" : "₹" + n.toLocaleString("en-IN");
    };

    const handleEditChange = (e) => {
        setEditFields({ ...editFields, [e.target.name]: e.target.value });
    };

    const handleConfirm = () => {
        setConfirming(true);
        setError("");
        setSuccess("");

        const formData = new URLSearchParams();
        formData.append("status", "Confirmed");
        // Append all editable fields
        Object.keys(editFields).forEach((key) => {
            // If the payment mode is RTGS, do not send received_by
            if (key === "received_by" && editFields.payment_mode === "RTGS") {
                formData.append(key, "");
            } else {
                formData.append(key, editFields[key]);
            }
        });

        fetch(`${API_BASE}/api/updatedatas`, {
            method: "POST",
            headers: { Authorization: "1", Table: "payments", Id: String(payment.id) },
            body: formData,
        })
            .then((r) => r.json())
            .then((json) => {
                setConfirming(false);
                if (json.status === true) {
                    setSuccess("Payment confirmed successfully!");
                    setTimeout(() => navigate(-1), 1800);
                } else {
                    setError(json.message || "Failed to confirm payment.");
                }
            })
            .catch(() => {
                setConfirming(false);
                setError("Error confirming payment. Please try again.");
            });
    };

    const displayMode = editFields.payment_mode || payment.payment_mode || "";
    const showUTR = displayMode === "Phonepe/UPI" || displayMode === "RTGS";
    const showCheque = displayMode === "Cheque/DD";
    const showHandover = displayMode === "Cheque/DD" || displayMode === "Cash";
    const showReceivedBy = displayMode !== "RTGS";



    return (
        <>
            <style>{`
        .cp-page { max-width:860px; margin:0 auto; }
        .cp-hdr { display:flex; align-items:center; gap:14px; margin-bottom:24px; }
        .cp-back { padding:8px 16px; background:#f8fafc; border:1px solid #e2e8f0; border-radius:10px; color:#334155; cursor:pointer; font-size:14px; font-weight:500; font-family:'Inter',sans-serif; transition:all .2s; display:flex; align-items:center; gap:6px; }
        .cp-back:hover { background:#f1f5f9; border-color:#cbd5e1; }
        .cp-title { font-size:22px; font-weight:700; color:#0f172a; }
        .cp-sub { font-size:13px; color:#64748b; }

        .cp-alert { padding:14px 18px; border-radius:12px; font-size:14px; margin-bottom:20px; font-weight:600; display:flex; align-items:center; gap:10px; }
        .cp-alert-ok { background:linear-gradient(135deg,#ecfdf5,#d1fae5); color:#059669; border:1px solid #a7f3d0; }
        .cp-alert-err { background:linear-gradient(135deg,#fef2f2,#fee2e2); color:#dc2626; border:1px solid #fecaca; }

        .cp-card { background:#fff; border:1px solid #e2e8f0; border-radius:16px; box-shadow:0 1px 4px rgba(0,0,0,.04); overflow:hidden; }

        .cp-status-bar { padding:16px 24px; display:flex; align-items:center; justify-content:space-between; background:linear-gradient(135deg,#fffbeb,#fef3c7); border-bottom:1px solid #fde68a; }
        .cp-status-left { display:flex; align-items:center; gap:10px; }
        .cp-status-dot { width:10px; height:10px; border-radius:50%; background:#f59e0b; animation:cp-pulse 1.5s ease-in-out infinite; }
        @keyframes cp-pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.2)} }
        .cp-status-text { font-size:14px; font-weight:700; color:#92400e; }
        .cp-status-badge { background:#f59e0b; color:#fff; padding:4px 14px; border-radius:20px; font-size:11px; font-weight:700; letter-spacing:.5px; }

        .cp-section { padding:24px; border-bottom:1px solid #f1f5f9; }
        .cp-section:last-of-type { border-bottom:none; }
        .cp-sec-title { font-size:14px; font-weight:700; color:#0f172a; margin-bottom:18px; display:flex; align-items:center; gap:8px; }
        .cp-sec-title span { font-size:16px; }

        .cp-grid { display:grid; grid-template-columns:1fr 1fr; gap:0; }
        .cp-detail-row { display:flex; justify-content:space-between; align-items:center; padding:12px 16px; border-radius:10px; transition:background .15s; }
        .cp-detail-row:hover { background:#f8fafc; }
        .cp-detail-label { font-size:13px; color:#64748b; font-weight:500; display:flex; align-items:center; gap:6px; }
        .cp-detail-icon { font-size:14px; }
        .cp-detail-value { font-size:14px; font-weight:600; color:#0f172a; text-align:right; }

        .cp-amount-highlight { padding:20px 24px; background:linear-gradient(135deg,#f0f9ff,#e0f2fe); border-bottom:1px solid #bae6fd; display:flex; align-items:center; justify-content:space-between; }
        .cp-amount-label { font-size:14px; font-weight:600; color:#0369a1; }
        .cp-amount-value { font-size:28px; font-weight:800; color:#0c4a6e; font-variant-numeric:tabular-nums; }

        /* Editable rows */
        .cp-edit-grid { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
        .cp-edit-row { display:flex; flex-direction:column; gap:5px; }
        .cp-edit-label { font-size:12px; font-weight:600; color:#64748b; text-transform:uppercase; letter-spacing:.4px; display:flex; align-items:center; gap:6px; }
        .cp-edit-icon { font-size:13px; }
        .cp-edit-input { padding:10px 14px; border-radius:10px; border:1px solid #e2e8f0; font-size:14px; font-family:'Inter',sans-serif; color:#1e293b; background:#f8fafc; outline:none; transition:all .2s; width:100%; box-sizing:border-box; }
        .cp-edit-input:focus { border-color:#818cf8; box-shadow:0 0 0 3px rgba(99,102,241,.1); background:#fff; }
        .cp-prev-value { font-size:11px; color:#94a3b8; margin-top:3px; padding-left:2px; }
        .cp-prev-value strong { color:#64748b; font-weight:600; }
        .cp-edit-note { font-size:11px; color:#94a3b8; margin-top:0; font-style:italic; display:flex; align-items:center; gap:4px; font-weight:400; }

        .cp-actions { padding:24px; display:flex; gap:14px; justify-content:flex-end; background:#fafbfc; border-top:1px solid #f1f5f9; }
        .cp-cancel-btn { padding:12px 24px; background:#f8fafc; color:#64748b; border:1px solid #e2e8f0; border-radius:10px; font-size:14px; font-weight:500; cursor:pointer; font-family:'Inter',sans-serif; transition:all .2s; }
        .cp-cancel-btn:hover { background:#f1f5f9; color:#334155; border-color:#cbd5e1; }

        .cp-confirm-btn { padding:12px 32px; background:linear-gradient(135deg,#059669,#10b981); color:#fff; border:none; border-radius:10px; font-size:15px; font-weight:700; cursor:pointer; font-family:'Inter',sans-serif; transition:all .25s; display:flex; align-items:center; gap:8px; box-shadow:0 4px 14px rgba(5,150,105,.25); letter-spacing:.3px; }
        .cp-confirm-btn:hover:not(:disabled) { background:linear-gradient(135deg,#047857,#059669); box-shadow:0 6px 20px rgba(5,150,105,.35); transform:translateY(-2px); }
        .cp-confirm-btn:disabled { opacity:.6; cursor:not-allowed; transform:none; }

        .cp-spinner { width:16px; height:16px; border:2px solid rgba(255,255,255,.3); border-top-color:#fff; border-radius:50%; animation:cp-sp .6s linear infinite; display:inline-block; }
        @keyframes cp-sp { to{transform:rotate(360deg)} }

        @media(max-width:768px){
          .cp-grid{grid-template-columns:1fr;}
          .cp-edit-grid{grid-template-columns:1fr;}
          .cp-card{border-radius:12px;}
          .cp-actions{flex-direction:column;}
          .cp-confirm-btn,.cp-cancel-btn{width:100%;justify-content:center;}
          .cp-amount-highlight{flex-direction:column;align-items:flex-start;gap:4px;}
        }
      `}</style>

            <div className="cp-page">
                <div className="cp-hdr">
                    <button className="cp-back" onClick={() => navigate(-1)}>← Back</button>
                    <div>
                        <div className="cp-title">Confirm Payment</div>
                        <div className="cp-sub">Review, edit details and confirm this received payment</div>
                    </div>
                </div>

                {success && <div className="cp-alert cp-alert-ok">✅ {success}</div>}
                {error && <div className="cp-alert cp-alert-err">⚠️ {error}</div>}

                <div className="cp-card">
                    {/* Status Bar */}
                    <div className="cp-status-bar">
                        <div className="cp-status-left">
                            <div className="cp-status-dot" />
                            <span className="cp-status-text">Payment Awaiting Confirmation</span>
                        </div>
                        <span className="cp-status-badge">RECEIVED</span>
                    </div>

                    {/* Amount Highlight */}
                    <div className="cp-amount-highlight">
                        <span className="cp-amount-label">💰 Payment Amount</span>
                        <span className="cp-amount-value">{fmt(payment.amount)}</span>
                    </div>

                    {/* Customer & Booking Info (read-only) */}
                    <div className="cp-section">
                        <div className="cp-sec-title"><span>👤</span> Customer & Booking</div>
                        <div className="cp-grid">
                            <DetailRow label="Customer Name" value={payment.customer_name} icon="🏷" />
                            <DetailRow label="Customer ID" value={payment.customer_id} icon="🆔" />
                            <DetailRow label="Booking ID" value={payment.booking_id} icon="📋" />
                            <DetailRow label="Unit" value={payment.unit} icon="🏠" />
                            <DetailRow label="Unit ID" value={payment.unit_id} icon="🔢" />
                            <DetailRow label="Project ID" value={payment.project_id} icon="📁" />
                        </div>
                    </div>

                    {/* Payment Info (read-only) */}
                    <div className="cp-section">
                        <div className="cp-sec-title"><span>💵</span> Payment Info</div>
                        <div className="cp-grid">
                            <DetailRow label="Payment ID" value={payment.payment_id} icon="🔖" />
                            <DetailRow label="Status" value={payment.status} icon="📊" />
                            <DetailRow label="Demand ID" value={payment.demand_id} icon="📄" />
                        </div>
                    </div>

                    {/* Dates (read-only) */}
                    <div className="cp-section">
                        <div className="cp-sec-title"><span>📅</span> Dates</div>
                        <div className="cp-grid">
                            <DetailRow label="Created" value={payment.payment_create} icon="🕐" />
                            <DetailRow label="Collection Date" value={payment.payment_collect} icon="📆" />
                        </div>
                    </div>

                    {/* Editable: Payment Details */}
                    <div className="cp-section">
                        <div className="cp-sec-title"><span>✏️</span> Payment Details <span className="cp-edit-note">— Editable</span></div>
                        <div className="cp-edit-grid">
                            <EditableSelect label="Payment For" name="payment_for" value={editFields.payment_for} onChange={handleEditChange} icon="📝" options={paymentForOptions} prev={payment.payment_for} />
                            <EditableSelect label="Payment Part" name="payment_part" value={editFields.payment_part} onChange={handleEditChange} icon="📑" options={paymentParts} prev={payment.payment_part} />
                            <EditableSelect label="Payment To" name="payment_to" value={editFields.payment_to} onChange={handleEditChange} icon="🏦" options={paymentToOptions} prev={payment.payment_to} />
                            <EditableSelect label="Payment Mode" name="payment_mode" value={editFields.payment_mode} onChange={handleEditChange} icon="💳" options={paymentModes} prev={payment.payment_mode} />
                            {showHandover && <EditableSelect label="Handover" name="handover" value={editFields.handover} onChange={handleEditChange} icon="📤" options={handoverToOptions} prev={payment.handover} />}
                            {showReceivedBy && <EditableSelect label="Received By" name="received_by" value={editFields.received_by} onChange={handleEditChange} icon="🤝" options={receivedByOptions} prev={payment.received_by} />}
                        </div>
                    </div>

                    {/* Editable: Cheque / UTR Details */}
                    {(showCheque || showUTR) && (
                        <div className="cp-section">
                            <div className="cp-sec-title"><span>🏦</span> Cheque / UTR Details <span className="cp-edit-note">— Editable</span></div>
                            <div className="cp-edit-grid">
                                {showCheque && (
                                    <>
                                        <EditableInput label="Cheque No" name="cheque_no" value={editFields.cheque_no} onChange={handleEditChange} icon="🔢" placeholder="e.g. 123456" prev={payment.cheque_no} />
                                        <EditableSelect label="Cheque Bank" name="cheque_bank" value={editFields.cheque_bank} onChange={handleEditChange} icon="🏛" options={bankOptions} prev={payment.cheque_bank} />
                                        <EditableInput label="Cheque Date" name="cheque_date" value={editFields.cheque_date} onChange={handleEditChange} icon="📅" type="date" prev={payment.cheque_date} />
                                    </>
                                )}
                                {showUTR && (
                                    <EditableInput label="UTR Number" name="utr" value={editFields.utr} onChange={handleEditChange} icon="🔗" placeholder="e.g. UTR123456789" prev={payment.utr} />
                                )}
                            </div>
                        </div>
                    )}

                    {/* Comment (read-only) */}
                    {payment.comment && (
                        <div className="cp-section">
                            <div className="cp-sec-title"><span>💬</span> Notes</div>
                            <div style={{ padding: "0 16px", fontSize: "14px", color: "#334155", lineHeight: 1.6 }}>
                                {payment.comment}
                            </div>
                        </div>
                    )}

                    <div className="cp-actions">
                        <button
                            className="cp-cancel-btn"
                            onClick={() => navigate(-1)}
                            disabled={confirming}
                        >
                            Cancel
                        </button>
                        <button
                            className="cp-confirm-btn"
                            onClick={handleConfirm}
                            disabled={confirming || !!success}
                        >
                            {confirming && <span className="cp-spinner" />}
                            {confirming ? "Confirming..." : "✅ Confirm Payment"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConfirmPayment;
